import React from 'react';

import { useUnmount } from 'react-use';
import { observer } from 'mobx-react';

import { useGetNecessaryData } from '../../../shared/hooks/useGetNecessaryData';
import { TaxInfoBlock } from '../../components/TaxInfoBlock/TaxInfoBlock';
import { scanIqTaxStore } from '../../stores/scanIqTaxStore';

type ScanIqTaxWidgetProps = {
  entityId: number;
};

const ScanIqTaxWidget = observer(({ entityId }: ScanIqTaxWidgetProps) => {
  const { entityTaxRate, changeTaxRate, getTaxInfo, setDefaultValues } = scanIqTaxStore;

  useGetNecessaryData(async () => {
    await getTaxInfo(entityId);
  });

  useUnmount(setDefaultValues);

  return (
    <TaxInfoBlock
      taxRateInfo={entityTaxRate}
      description={
        <>
          Set the tax percentage based on your state/city.
          <br />
          Upon tax setup, the subscription amount will be adjusted to reflect the
          applicable tax.
        </>
      }
      isActive={!!entityTaxRate?.id}
      onSetTaxRate={changeTaxRate}
    />
  );
});

export { ScanIqTaxWidget };
